import React               from 'react'
import { SnackbarActions, TokenActions } from 'actionsets'
import StyleSheet          from 'styles'
import { CenteredCard } from 'components'

export const StatusPageMixin = superclass => class extends superclass{
  constructor(props){
    super(props)
    this.styles = styles
    this.state = { }
    SnackbarActions.bindActions(this, 'snackbar')
    TokenActions.bindActions(this)
  }

  goBack = steps => {
    if(steps){
      return () => this.props.history.go(steps)
    }
    this.props.history.go(this.props.match.isExact ? -2 : -1)
  }

  goToRoot = () => {
    this.props.history.push('/')
  }

  get maxWidth(){
    return 400
  }

  render = () =>
    <CenteredCard centerVertically={true} className={styles.card} style={{maxWidth: this.maxWidth}}>
      {this.body()}
    </CenteredCard>
}

const styles = StyleSheet({
  card: {
    margin: 0,
    padding: 25,
    textAlign: 'left',
    maxWidth: 700,
    '& h6': {
      marginBottom: 15
    },
    '& p, & aside': {
      marginBottom: 15
    }
  },
  button: {
    margin: 15
  }
})

export default StatusPageMixin